import React from 'react';
import PropTypes from 'prop-types';

import {
  ProductName,
} from 'anf-core-react';

import ColorSizeText from '../color-size-text/color-size-text';
import ExchangeButton from '../exchange-button/exchange-button';
import ExchangeProductImage from '../exchange-product-image/exchange-product-image';
import TmntText from '../tmnt-text/tmnt-text';
import ReturnReason from '../return-reason/return-reason';

export default function ExchangeDisplay({
  product,
  showReturnReason,
  selectedProductComments,
}) {
  return (
    <div className="exchange-display">
      <div className="exchange-display-header">
        <div className="exchange-display-header-content">
          <ProductName>{product.name}</ProductName>
          <p>
            <TmntText k="BAG_SKU" />
            {' '}
            {product.partNumber}
          </p>
          {showReturnReason && (
            <ReturnReason
              selectedProductComments={selectedProductComments[product.orderLineKey]}
              orderLineKey={product.orderLineKey}
            />
          )}
        </div>
        <ExchangeButton product={product} />
      </div>
      <div className="exchange-display-columns">
        <div className="exchange-display-column">
          <h5>
            <TmntText k="DRE_ORIGINAL_ITEM" />
          </h5>
          <ColorSizeText product={product} />
          <ExchangeProductImage imageId={product.imageId} collection={product.collection} />
        </div>
        <div className="exchange-display-column">
          <h5>
            <TmntText k="DRE_NEW_ITEM" />
          </h5>
          <ColorSizeText product={product.exchange} />
          <ExchangeProductImage
            imageId={product.exchange.imageId}
            collection={product.exchange.collection}
          />
        </div>
      </div>
    </div>
  );
}

ExchangeDisplay.propTypes = {
  product: PropTypes.shape({
    productId: PropTypes.string,
    orderLineKey: PropTypes.string,
    collection: PropTypes.string,
    partNumber: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    imageId: PropTypes.string,
    exchange: PropTypes.shape({
      swatch: PropTypes.string,
      sizePrimary: PropTypes.string,
      imageId: PropTypes.string,
      collection: PropTypes.string,
    }),
  }).isRequired,
  showReturnReason: PropTypes.bool,
  selectedProductComments: PropTypes.object,
};
